// extracted by mini-css-extract-plugin
module.exports = {"card":"about-us-card_card__k1gmj","icon":"about-us-card_icon__2FObz","title":"about-us-card_title__2tOaF"};